var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5ZM9.5625 6C9.5625 5.68934 9.31066 5.4375 9 5.4375C8.68934 5.4375 8.4375 5.68934 8.4375 6V6.75C8.4375 7.06066 8.68934 7.3125 9 7.3125C9.31066 7.3125 9.5625 7.06066 9.5625 6.75V6ZM9.5625 8.625C9.5625 8.31434 9.31066 8.0625 9 8.0625C8.68934 8.0625 8.4375 8.31434 8.4375 8.625V12C8.4375 12.3107 8.68934 12.5625 9 12.5625C9.31066 12.5625 9.5625 12.3107 9.5625 12V8.625Z",
    fill: "#C7CBD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.7122b85fce73b0bb5ae54e0b340e2ed7.svg";
export { ForwardRef as ReactComponent };